import { render, staticRenderFns } from "./DropdownConfigView.vue?vue&type=template&id=49b93d98&scoped=true&"
import script from "./DropdownConfigView.vue?vue&type=script&lang=js&"
export * from "./DropdownConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b93d98",
  null
  
)

export default component.exports